/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ManufacturerCompany } from '../../models/manufacturer-company';
import { UpdateManufacturerDto } from '../../models/update-manufacturer-dto';

export interface UpdateOneBaseMgmtManufacturerControllerManufacturerCompany$Params {
  id: number;
      body: UpdateManufacturerDto
}

export function updateOneBaseMgmtManufacturerControllerManufacturerCompany(http: HttpClient, rootUrl: string, params: UpdateOneBaseMgmtManufacturerControllerManufacturerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<ManufacturerCompany>> {
  const rb = new RequestBuilder(rootUrl, updateOneBaseMgmtManufacturerControllerManufacturerCompany.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ManufacturerCompany>;
    })
  );
}

updateOneBaseMgmtManufacturerControllerManufacturerCompany.PATH = '/api/mgmt/manufacturers/{id}';
